import { ErrorBoundary } from '@toss/error-boundary';
import { useRouter } from 'next/router';
import { SubscriptionRejectedFallback } from '../../../../../components/service/subscription/components/SubscriptionRejectedFallback';
import { PlanSpaceDetailProvider } from '../../../../../components/service/subscription/plan';
import { SubscribePlanSection } from '../../../../../components/service/subscription/plan/SubscribePlanSection';
export const SubscribePlanPageView = () => {
  const {
    query
  } = useRouter();
  return <ErrorBoundary renderFallback={fallbackProps => <SubscriptionRejectedFallback {...fallbackProps} />} data-sentry-element="ErrorBoundary" data-sentry-component="SubscribePlanPageView" data-sentry-source-file="subscribe-plan.tsx">
      <PlanSpaceDetailProvider spaceHashId={query.id as string} data-sentry-element="PlanSpaceDetailProvider" data-sentry-source-file="subscribe-plan.tsx">
        <SubscribePlanSection data-sentry-element="SubscribePlanSection" data-sentry-source-file="subscribe-plan.tsx" />
      </PlanSpaceDetailProvider>
    </ErrorBoundary>;
};